import { PieChart as PieChartIcon } from 'lucide-react';
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

interface DepartmentMetrics {
  department: string;
  completion_rate: number;
}

interface CompletionRatesChartProps {
  data: DepartmentMetrics[];
}

const COLORS = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899'];

export function CompletionRatesChart({ data }: CompletionRatesChartProps) {
  // Ensure completion rates are capped at 100%
  const normalizedData = data.map(item => ({
    ...item,
    completion_rate: Math.min(item.completion_rate, 100) // Cap at 100%
  }));

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
      <div className="flex items-center mb-4">
        <PieChartIcon className="h-5 w-5 text-blue-500 dark:text-blue-400" />
        <h2 className="ml-2 text-lg font-semibold text-gray-900 dark:text-white">
          Completion Rates by Department
        </h2>
      </div>
      <div className="h-[300px] w-full">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={normalizedData}
              nameKey="department"
              dataKey="completion_rate"
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={100}
              fill="#8884d8"
              paddingAngle={5}
              label={({ department, completion_rate }) => 
                `${department}: ${completion_rate}%`
              }
            >
              {normalizedData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip
              formatter={(value) => `${value}%`}
              contentStyle={{
                backgroundColor: '#1F2937',
                border: 'none',
                borderRadius: '0.375rem',
                color: '#F3F4F6',
                fontSize: '12px'
              }}
            />
            <Legend
              formatter={(value) => `${value}`}
              wrapperStyle={{
                paddingTop: '20px',
                fontSize: '12px'
              }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}